<app-invoices-segments-filters></app-invoices-segments-filters>
<div class="row" [class.loading]="loading">
  <div class="col-lg-{{ showProviders ? 7 : 12 }} col-xl-{{ showProviders ? 8 : 12 }}">
    <app-invoices-bar-chart (hasData)="showDisclaimer = $event"></app-invoices-bar-chart>
  </div>
  <div class="col-lg-5 col-xl-4" *ngIf="(isDesktop$ | async) && showProviders">
    <app-invoices-providers></app-invoices-providers>
  </div>
</div>
<ng-container *ngIf="reportState$ | async as reportState">
  <ng-container *ngIf="optionsState$ | async as optionsState">
    <div class="buttons-list">
      <ng-container *ngIf="buttonsAllowed">
        <button
          *ngIf="(isDesktop$ | async) === false && showProviders"
          (click)="showModal(providersModal)"
          type="button"
          class="btn btn-outline-primary me-sm-2"
        >
          {{ getButtonKey(optionsState.segment) }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="loadReportFile()"
          i18n="@@segments.accountInvoicesDownload"
        >
          <span class="fa-download me-2" aria-hidden="true"></span>Download the report
        </button>
      </ng-container>
    </div>
    <ng-template #providersModal let-c="close">
      <div class="modal-header">
        <h2 class="modal-title">{{ getTitleKey(optionsState.segment) }}</h2>
        <button type="button" class="btn-close" aria-label="Close" (click)="c()">
        </button>
      </div>
      <div class="modal-body">
        <app-invoices-providers></app-invoices-providers>
      </div>
    </ng-template>
  </ng-container>
</ng-container>

<div *ngIf="showDisclaimer" class="message data-disclaimer" [class.loading]="loading">
  <p i18n="@@documents.accountInvoicesDisclaimer">
    The information provided by Amadeus on this page is believed to be accurate, but no representation or warranty is
    given (express or implied) as to its accuracy, completeness or correctness. In the event of any inconsistency
    between the information provided by Amadeus on this page and any other information provided by Amadeus for the
    purposes of determining any financial or contractual obligation (including, but not limited to, incentives or
    Amadeus Products charges), the books and records of Amadeus will be final and conclusive
  </p>
</div>
<spinner *ngIf="loading" [fixed]="true"></spinner>
